import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AuthenticatedLayoutModule } from './authenticated-layout/authenticated-layout.module';
import { ComponentsModule } from './components/components.module';
import { MaterialModule } from './material/material.module';
import { PipesModule } from './pipes/pipes.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { APP_DATE_FORMATS, AppDateAdapter } from './formatters/date-format';

const MODULES: any = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MaterialModule,
  RouterOutlet,
  NgxMaskDirective,
  PipesModule,
  ComponentsModule,
  AuthenticatedLayoutModule,
];

registerLocaleData(localePt);

@NgModule({
  declarations: [],
  imports: [...MODULES],
  exports: [...MODULES],
  providers: [
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
  ],
})
export class CoreModule { }
